import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import { NotFound } from 'src/ui/components/NotFound';
import { PrivateRoute } from 'src/ui/components/PrivateRoute';
import { ManageApiTokens } from 'src/ui/containers/api-tokens/ManageApiTokens';
import { Diagnostic } from 'src/ui/containers/diagnostic/Diagnostic';
import { LaunchpadEndpoints } from 'src/ui/containers/endpoints/LaunchpadEndpoints';
import { LaunchpadDashboard } from 'src/ui/containers/launchpad/dashboard/LaunchpadDashboard';
import { LaunchpadSduDashboard } from 'src/ui/containers/launchpad/dashboard/LaunchpadSduDashboard';
import { LaunchpadSduDashboardEndpoint } from 'src/ui/containers/launchpad/dashboard/LaunchpadSduDashboardEndpoint';
import { Login } from 'src/ui/containers/launchpad/Login';
import { Share } from 'src/ui/containers/share/Share';
import { VoiceboxPage } from 'src/ui/containers/voicebox/VoiceboxPage';

export const LaunchpadAppBody: React.VFC = () => {
  return (
    <div className="sd-app-body">
      <div className="sd-vertical">
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <PrivateRoute exact path="/">
            <LaunchpadDashboard />
          </PrivateRoute>
          <PrivateRoute exact path="/connections">
            <LaunchpadEndpoints />
          </PrivateRoute>
          <PrivateRoute exact path="/units">
            <LaunchpadSduDashboard />
          </PrivateRoute>
          <PrivateRoute exact path="/units/:index(\d+)">
            <LaunchpadSduDashboardEndpoint />
          </PrivateRoute>
          <PrivateRoute exact path="/u/:id(\d+)/">
            <LaunchpadDashboard />
          </PrivateRoute>
          <PrivateRoute path="/u/:id(\d+)/diagnostic">
            <Diagnostic />
          </PrivateRoute>
          <PrivateRoute
            exact
            path="/u/:id(\d+)/voicebox/:conversation?"
            voiceboxOnly
          >
            <VoiceboxPage />
          </PrivateRoute>
          <PrivateRoute exact path="/keys" voiceboxAPIAccessEnabled>
            <ManageApiTokens />
          </PrivateRoute>
          <PrivateRoute path="/share/:hash([\w\d]+)">
            <Share />
          </PrivateRoute>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
      </div>
    </div>
  );
};
